import { ESiteDocumentType } from "@/types/backoffice/dto/site-documents/site-document-dto";

const documentTypes: Record<ESiteDocumentType, string> = {
  [ESiteDocumentType.ESC_INVOICE]: "Facture CEE",
  [ESiteDocumentType.ESC_ESTIMATE_PAPER_PHOTO]: "Devis papier CEE",
  [ESiteDocumentType.ELECTRONIC_SEALED_DOCUMENT]: "Photos horodatées",
  [ESiteDocumentType.YOUSIGN_AUDIT_TRAIL]: "Suivi de signature Yousign",
  [ESiteDocumentType.ESC_QUOTE]: "Devis CEE",
  [ESiteDocumentType.INSTALLATION_SHEET]: "Fiche d'installation",
  [ESiteDocumentType.INSTALLATION_SHEET_BASIC]: "Fiche d'installation basic",
  [ESiteDocumentType.ESC_SWORN_STATEMENT]: "Attestation sur l'honneur CEE",
  [ESiteDocumentType.TAX_REDUCTION_STATEMENT]: "Attestation de TVA simplifiée",
  [ESiteDocumentType.ELECTRICITY_BILL]: "Facture d'électricité",
  [ESiteDocumentType.TRANSFER_SALES]: "Fiche de transfert CGU",
  [ESiteDocumentType.TRANSFER_PROVISION]: "Fiche de transfert CGM",
  [ESiteDocumentType.INTERVENTION_SALES]: "Fiche de maintenance - vente",
  [ESiteDocumentType.INTERVENTION_PROVISION]: "Fiche de maintenance - MàD",
  [ESiteDocumentType.ESC_CREDIT_NOTE]: "Avoir de facture",
  [ESiteDocumentType.ESTIMATE_ESC_STATEMENT]: "Attestation de devis",
  [ESiteDocumentType.ESC_CUSTOMER_SERVICE_CERTIFICATE]: "Attestation de SAV",
  [ESiteDocumentType.ELECTRICITY_BILL_PHOTO_PDF]: "Photo facture éléctricité",
};

const siteDocuments = {
  siteDocuments: {
    confirm: {
      mail: {
        message:
          'Vous êtes sur le point d’envoyer un e-mail à l’adhérent avec le fichier "{document}". Voulez-vous confirmer l’envoi ?',
        acceptLabel: "Oui, envoyer",
        rejectLabel: "Annuler",
      },
    },
    toast: {
      mail: {
        error: {
          notMailable: "Le document ne peut pas être envoyé par e-mail.",
          noSite: "Aucun site actif n’a été trouvé. Merci de rafraîchir la page.",
          noSubscriber: "Aucun adhérent n’est rattaché à ce site.",
          genericError: "Une erreur est survenue. Merci de réessayer ultérieurement.",
        },
        success: {
          sent: 'Le mail contenant le document "{document}" a bien été envoyé à l’adhérent. Il le recevra dans sa boîte de réception d\'ici quelques instants.',
        },
      },
    },
    pageTitle: "Documents",
    table: {
      unknown: "Inconnu",
      headers: {
        name: "Nom",
        size: "Taille",
        date: "Date",
        origin: "Origine",
        actions: "",
        ocrResultStatus: "Statut du document",
      },
      mail: {
        tooltip: "Envoyer par mail",
      },
    },
    documentTypes,
    empty: {
      title: "Aucun document",
      description: "Aucun document n'a été ajouté pour le moment.",
    },
    error: {
      title: "Erreur",
      description: "Une erreur est survenue lors du chargement des documents.",
    },
  },
};

export type SiteDocumentsLocale = typeof siteDocuments;
export default siteDocuments;
